import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { ContractSearchService } from '../Services/contract-search.service';

@Pipe({
    name: 'listviewContent',

})
export class ListViewContentPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer, private dataService: ContractSearchService) { }


    transform(value: any, args: any, filterMetadata: any, index: any, initialLoad: boolean): any {

        if (!args) {
            return value;
        }

        if (!args || /[<>{}]/.test(args)) {
            return value;
        }

        if (args != undefined && args.length < 3) {
            index.count = 0;
            this.dataService.setCurrentPosition(index.count);
            return value;
        }

        //value = value.replace(/<[^>]*>/g, '');
        // Match in a case insensitive maneer
        const re = new RegExp(`(?![^<>]*>)${args}`, 'gi');
        const match = value.changingThisBreaksApplicationSecurity.match(re);

        // If there's no match, just return the original value.
        if (!match) {
            if (!initialLoad) {
                return value;
            }
            else {
                this.dataService.setCurrentPosition(index.count);
                this.dataService.setTotalSearchCount(filterMetadata.count);
                return value;
            }
        }

        if (match.length > 0) {
            if (initialLoad) {
                var searchResult;
                //search the text when text entered in search bar
                this.dataService.setCurrentPosition(index.count);
                filterMetadata.count > 0 ? searchResult = activeHighlight(value, re, null) : searchResult = activeHighlight(value, re, index.count);
                filterMetadata.count += match.length;
                this.dataService.setTotalSearchCount(filterMetadata.count);/// send total count of highlights to the service.
                index.count = index.count + 1;
                this.dataService.setCurrentPosition(index.count);
                return this.sanitizer.bypassSecurityTrustHtml(searchResult);
            }
            else {
                // change the activation based on next and previous button
                if (index.count != undefined) {
                    var activePos = index.count;
                    const searchResult = activeHighlight(value, re, activePos - 1);
                    return this.sanitizer.bypassSecurityTrustHtml(searchResult);
                }
                else {
                    var activePosition = index;

                    if (activePosition != undefined) {
                        const searchHighlightResult = activeHighlight(value, re, activePosition);
                        return this.sanitizer.bypassSecurityTrustHtml(searchHighlightResult);
                    }
                    else {
                        const searchResults = activeHighlight(value, re, null);
                        return this.sanitizer.bypassSecurityTrustHtml(searchResults);
                    }
                }
            }

        }

        function activeHighlight(val, reVal, active) {
            var position = 0;
            const result = val.changingThisBreaksApplicationSecurity.replace(reVal, function (param) {
                if (position == active) {
                    position++;
                    return "<mark class='swapa-contract-active'>" + param + "</mark>"
                }
                else {
                    position++;
                    return "<mark class='swapa-contract-highlight'>" + param + "</mark>"
                }
            });
            return result;
        }
    }
}
